import userManager from './auth.ts';
import type { User } from 'oidc-client-ts';
import config from '../config.json';

export async function getUser(): Promise<User | null> {
  return userManager.getUser();
}

export async function login(): Promise<void> {
  return userManager.signinRedirect();
}

export async function logout(): Promise<void> {
  await userManager.removeUser();
  await userManager.clearStaleState();
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = `${config.authority}/logout`;
}

export async function getToken(): Promise<string | null> {
  const user = await userManager.getUser();
  if (!user || user.expired) {
    try {
      const refreshed = await userManager.signinSilent();
      return refreshed?.access_token ?? null;
    } catch {
      return null;
    }
  }
  return user.access_token;
}

export async function getUserGroups(): Promise<string[]> {
  const user = await userManager.getUser();
  if (!user) return [];

  try {
    const res = await fetch(`${config.authority}/api/oidc/userinfo`, {
      headers: {
        Authorization: `Bearer ${user.access_token}`
      }
    });
    const info = await res.json();
    return info.groups ?? [];
  } catch {
    return [];
  }
}

export function isAdmin(user: User | null): boolean {
  if (!user) return false;
  const groups: string[] = (user.profile as any).groups ?? [];
  return groups.includes('admin');
}
